import React, {
    useState,
    useEffect
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    makeStyles
} from '@material-ui/styles';
import {
    Grid
} from '@material-ui/core';
import {
    classBody
} from '@babel/types';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider,
    Table,
    Snackbar,
    TableBody,
    TableRow,
    TableCell,
    colors
} from '@material-ui/core';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import Available_showrooms from './Available_showrooms';
import Showroom_booking from './Showroom_booking';
import Create_booking from './Create_booking';
import MuiAlert from '@material-ui/lab/Alert';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3)
    },
    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        },

    },

    flexend: {
        justifyContent: 'flex-end',
    }
    // pdTop: {
    //     paddingTop: '30px',
    // }
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export default class Dashboard_agency extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            forms: '',
            forms_param: null,
            timeslot_id: null,
            date: null,
            max_pax: 0
        };

    }

    create_booking(timeslot_id, date, max_pax, showroom) {
        this.setState({
            forms: 'create',
            timeslot_id: timeslot_id,
            date: date,
            max_pax: max_pax,
            showroom: showroom
        });
    }
    close_form() {
        this.setState({
            ...this.state,
            forms: ""
        });
    }
    deleteSuccess() {
        this.setState({
            ...this.state,
            remove_toast: true
        });
    }
    show_booking(appointment_id, max_pax, timeslot, date) {
        this.setState({
            forms: 'info',
            forms_param: appointment_id,
            max_pax: max_pax,
            timeslot: timeslot,
            date: date
        });
    }
    refresh_action() {
        this.close_form();
        this.available_showroom.get_data();
    }
    create_success() {
        this.setState({
            ...this.state,
            toast: true,
            forms: ''
        });
        this.available_showroom.get_data();
    }
    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <div className={clsx(this.props.classes.root, this.props.className)}>
                        <Grid container spacing={1}>
                            <Grid item md={12}>
                                <Available_showrooms
                                    ref={(ref) => this.available_showroom = ref}
                                    infoAction={this.show_booking.bind(this)}
                                    closeFormAction={this.close_form.bind(this)}
                                    createAction={this.create_booking.bind(this)}
                                ></Available_showrooms>
                            </Grid>
                            <Grid item md={4}>
                                {
                                    this.state.forms == 'info' ?
                                        <Showroom_booking 
                                            deleteSuccess={this.deleteSuccess.bind(this)}
                                            open={this.state.forms == 'info' ? true : false}
                                            timeslot={this.state.timeslot}
                                            appointment_id={this.state.forms_param}
                                            max_pax={this.state.max_pax}
                                            handleClose={this.refresh_action.bind(this)}
                                            date={this.state.date}
                                            classes={this.props.classes}></Showroom_booking>
                                        : (this.state.forms == 'create' ?
                                            <Create_booking
                                                showroom={this.state.showroom}
                                                open={this.state.forms == 'create' ? true : false}
                                                successAction={this.create_success.bind(this)}
                                                timeslot_id={this.state.timeslot_id}
                                                max_pax={this.state.max_pax}
                                                handleClose={this.refresh_action.bind(this)}
                                                date={this.state.date}
                                                classes={this.props.classes}></Create_booking>
                                            : '')
                                }

                            </Grid>
                        </Grid>
                    </div>
                </main>
                <Snackbar open={this.state.toast} autoHideDuration={2000} onClose={() => {
                    this.setState({
                        ...this.state,
                        toast: false
                    });
                }}>
                    <Alert onClose={() => {
                        this.setState({
                            ...this.state,
                            toast: false
                        })
                    }
                    } severity="success">
                        Added
                </Alert>
                </Snackbar>
                <Snackbar open={this.state.remove_toast} autoHideDuration={2000} onClose={() => {
                    this.setState({
                        ...this.state,
                        remove_toast: false
                    });
                }}>
                    <Alert onClose={() => {
                        this.setState({
                            ...this.state,
                            remove_toast: false
                        })
                    }
                    } severity="error">
                        Removed
                </Alert>
                </Snackbar>
            </React.Fragment>
        )
    }

}
